import React, { useState, useRef, useEffect } from "react";
import { Paper, BottomNavigation, BottomNavigationAction, Box} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info"; // ou autre icône
import PollIcon from "@mui/icons-material/Poll";
import ContactsIcon from "@mui/icons-material/Contacts";
import ListIcon from "@mui/icons-material/List";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import CalculateIcon from "@mui/icons-material/Calculate";
import { useNavigate, useLocation } from "react-router-dom";

import BouleFacette from "../images/Boule-facette-bleu-jaune-05.png";
import { logDev } from "../utils/logger.js";

import { useGroupe } from "../context/GroupeContext.js";
import { useLanguage } from '../context/LanguageContext.js';

const BottomNav = ({ isMobile, headerHeight, onHeightChange, onNoticeClick, contactsCount  }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  
  logDev("[BottomNav] headerHeight reçu", headerHeight);

    // 🔄 Synchroniser l'onglet actif avec l'URL
    useEffect(() => {
      switch (location.pathname) {
        case "/contacts":
          setValue(0);
          break;
        case "/survey":
          setValue(1);
          break;
        case "/menus":
          setValue(2);
          break;
        case "/liste":
          setValue(3);
          break;
        case "/infos":
          setValue(4);
          break;
        case "/compta":
          setValue(5);
          break;
        default:
          setValue(0); // fallback
      }
  }, [location.pathname]);
  
  const { t } = useLanguage();
  const { role } = useGroupe();
  const isAdmin = role === "admin";
  const navRef = useRef(null);
  logDev("[BottomNav] props reçues", { isAdmin, contactsCount });

  // Mesurer la hauteur au montage et sur resize
  useEffect(() => {
    const updateHeight = () => {
      if (navRef.current && typeof onHeightChange === "function") {
        onHeightChange(navRef.current.offsetHeight);
      }
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [onHeightChange]);

  const handleNavigation = (newValue) => {
    /*setValue(newValue);*/
    switch (newValue) {
      case 0:
        navigate("/contacts");
        break;
      case 1:
        navigate("/survey");
        break;     
      case 2:
        navigate("/menus");
        break;
      case 3:
        navigate("/liste");
        break;
      case 4:
        navigate("/infos");
        break;
      case 5:
        navigate("/compta");
        break;   
      default:
        break;  
    }
  };

  return (
    <Paper
      ref={navRef} // ✅ pour mesurer la hauteur
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        zIndex: 1000,
        bottom: isMobile ? 0 : "auto",                 // bas sur mobile
        /*top: isMobile ? "auto" : `${headerHeight + 32 }px`, */ // 👈 offset anti-recouvrement
        top: isMobile ? "auto" : `${headerHeight}px`,
        boxShadow: "0px -2px 8px rgba(0,0,0,0.25)"     // ombre vers le haut
      }}
      elevation={0}
    >
      {/*<Box sx={{ overflowX: "auto" }}>*/}
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => handleNavigation(newValue)}
        showLabels
        sx={{
          backgroundColor: "#e4dcd2",
          overflowX: "auto",     // 👈 ici, pas dans un Box
          whiteSpace: "nowrap",  // 👈 empêche la coupure
          pl: { xs: 10, sm: 0 }, // ✅ sur mobile (xs) on met un padding de 32px, sur desktop (sm et +) aucun
          "& .MuiBottomNavigationAction-root": {
            backgroundColor: "#e4dcd2",
            minWidth: 80, // 👈 largeur mini par bouton
          },
          "& .MuiBottomNavigationAction-label": {
            fontSize: "0.5rem",        // ✅ plus petit
            lineHeight: 1.2,
            },   
            "& .Mui-selected .MuiBottomNavigationAction-label": {
            fontSize: "0.65rem",       // ✅ légèrement plus grand si sélectionné
            fontWeight: "bold",
    }, 
        }}
      >
        <BottomNavigationAction 
        value={0} label={t("Contacts")}
        icon={<ContactsIcon sx={{ color: "#444" }} />} />
        <BottomNavigationAction 
        value={1} 
        label={t("Survey")}
        icon={<PollIcon />}
          sx={{ color: "#444" }} 
        />
        <BottomNavigationAction value={2} label={t("Menus")} icon={<RestaurantMenuIcon />} />
        <BottomNavigationAction value={3} label={t("List")} icon={<ListIcon />} />
        <BottomNavigationAction
        value={4} // <— on donne la valeur
        label={t("Party")}
        icon={
          <Box
            component="img"
            src={BouleFacette} // utilisation de l'import
            alt="Disco Ball"
            sx={{
              width: 48,
              height: 48,
              objectFit: "contain",
              display: "block",
            }}
          />
        }
        sx={{
          padding: 0,
          minWidth: 80,
          backgroundColor: "#e4dcd2",
        }}
          />  
        <BottomNavigationAction value={5} label={t("Compta")} icon={<CalculateIcon />} />
        {/* ✅ Bouton Notice visible uniquement sur desktop */}
        {!isMobile && (
        <BottomNavigationAction
          label={t("Notice")}
          icon={<InfoIcon />}
          onClick={onNoticeClick} // déclenche l'ouverture
        />
        )}
      </BottomNavigation>
      {/*</Box>*/}
    </Paper>
  );
};

export default BottomNav;
